module.exports = (__parcel__import__("nCscR")).then(() => parcelRequire('emu4l'));